/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable  */
/* tslint:disable:no-unused-variable */
import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
// import { AgGridReact } from '@ag-grid-community/react';
// import { AgGridStyle, AgGridTableWrapper } from '../../components/AgGridStyle';
// import { AllModules } from '@ag-grid-enterprise/all-modules';
import clsx from 'clsx';
import { formatNumber } from '../helpers/ChartHelper';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        width: '100%',
        display: 'flex',
        flexFlow: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'normal',
    },
    gridWrapper: {
        display: 'flex',
        flex: 1,
        flexFlow: 'column wrap',
        minHeight: '220px'
    },
    otherInfo: {
        padding: '10px',
    },
    // paper: {
    //     padding: '15px 10px 10px 10px',
    //     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    // },
    tableContainer: {
        display: 'flex',
        flexFlow: 'column',
        flex: 1,
        // padding: '0 10px'
    },
    tableHeader: {
        display: 'flex',
        alignItems: 'center',
        // margin: '0 -10px',
        gap: '10px',
        padding: '10px',
        backgroundColor: '#F5F6FF'
    },
    tableHeaderColumn: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        // padding: '10px'
    },
    tableBody: {
        flex: 1,
        display: 'flex',
        flexFlow: 'column',
        overflowY: 'auto'
    },
    tableBodyRow: {
        display: 'flex',
        flex: 1,
        // margin: '0 -10px',
        gap: '10px',
        padding: '10px',
        '&:nth-child(odd)': {

        },
        '&:nth-child(even)': {
            backgroundColor: '#F5F6FF'
        }
    },
    tableBodyColumn: {
        flex: 1,
        // padding: '10px'
    },
    leftAlign: {
        textAlign: 'left',
    },
    centerAlign: {
        textAlign: 'center',
    },
    rightAlign: {
        textAlign: 'right',
    },
  }),
);

interface ColumnProps<T> {
    key: keyof T;
    label: string;
    type?: 'string' | 'number' | 'date';
    cellRenderer?: (value: T) => React.ReactNode;
}
interface DataTablesProps<T> {
    columns: ColumnProps<T>[];
    data: T[];
    maxHeight?: number;
}

export const DataTables = <T, >(props: DataTablesProps<T>) => {

    const classes = useStyles();

    const formatCellValue = (value: any, type: string) => {
        if (type === 'number' && typeof value === 'number') {
            return formatNumber(value || 0);
        }
        return value;
    };
    
    const getColumnClass = (type: string) => {
        switch (type) {
            case 'string':
                return classes.leftAlign;
            case 'date':
                return classes.centerAlign;
            case 'number':
                return classes.rightAlign;
            default:
                return '';
        }
    };

    return (
        <div className={classes.root}>
            <div className={classes.tableContainer}>
                <div className={classes.tableHeader}>
                    {props.columns.map((column, index) => (
                        <div 
                            key={index}
                            className={classes.tableHeaderColumn}
                        >
                            {column.label}
                        </div>
                    ))}
                </div>
                <div 
                    className={classes.tableBody}
                    style={{
                        maxHeight: props.maxHeight ? `${props.maxHeight}px` : 'auto'
                    }}
                >
                    {props.data.map((row, rowIndex) => (
                        <div key={rowIndex} className={classes.tableBodyRow}>
                            {props.columns.map((column, colIndex) => (
                                <div 
                                    key={colIndex} 
                                    className={clsx(
                                        classes.tableBodyColumn,
                                        getColumnClass(column.type || 'string')
                                    )}
                                >
                                    {column.cellRenderer ? column.cellRenderer(row) : formatCellValue(row[column.key as keyof T], column.type || 'string')}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DataTables;